import React, { useState, useRef, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import Base64Downloader from 'common-base64-downloader-react';
import apis from '../../api';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { DataScroller } from 'primereact/datascroller';
import './DataScrollerDemo.css';
import useParamsCertificate from '../../helpers/useParamsCertificate'
import dateFormat from '../../services/DateFormat.service';
import { Label, LabelField } from './Certificate.styles';
import { InputText } from 'primereact/inputtext';
import Video from '../Video/Video';
import useParamsConfirmation from '../../helpers/useParamsConfirmation';
import { excelReport } from '../../services/excelReport.service';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Certificate
Description : Generación de reporte.
Date Autor Modification
================================================================================
04/11/2021 Cristian Andres Pizo Mina Creación 
05/4/2022 Cristian Andres Pizo Mina - Comentarios
================================================================================ */

export default function Accounting(props) {

    // declaración de constantes
    const [contenido, setContenido] = useState("")
    const toast = useRef(null);
    const [params] = useParamsCertificate();
    const [paramsConfirmation] = useParamsConfirmation();
    const [isOpen, setIsOpen] = React.useState(false);
    const [isOpenCorreo, setIsOpenCorreo] = React.useState(false);
    const [isOpenConfirmacion, setIsOpenConfirmacion] = React.useState(false);
    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [loading3, setLoading3] = useState(false);
    const [loading4, setLoading4] = useState(false);
    const [loading5, setLoading5] = useState(false);
    const [certificate, setCertificate] = useState([]);
    const [confirmation, setConfirmation] = useState([]);
    const elementWidth = { width: "60% ", justifySelf: "center" }
    const headers = { authorization: localStorage.getItem('token') }
    const [listPdf, setListPdf] = useState([]);
    const [correo, setCorreo] = useState(localStorage.getItem('user') ? localStorage.getItem('user') : "")

    // Idioma del componente Calendar
    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Claro'
    });

    // Nombre de lista de certificados
    useEffect(() => {
        let name = [{ name: 'Certificado Laboral' }]
        setListPdf(name);
    }, []);

    // inizializar select pinEntity
    useEffect(() => {
        const certificateTemplate = async () => {
            let plantilla = []
            params.forEach((p) => {
                if (p.TAG === 'pinEntity' || p.TAG === 'pinClient') {
                    plantilla.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION, REQUIRED: p.REQUIRED })
                }
                else {
                    if (localStorage.getItem('type') === 'CLIENT' && localStorage.getItem('number_id') && p.TAG === 'p_persona') {
                        plantilla.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION, REQUIRED: p.REQUIRED })
                    }
                    else {
                        plantilla.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                    }
                }
            })
            setCertificate(plantilla)
        }
        certificateTemplate()
    }, [params]);

    useEffect(() => {
        const confirmationTemplate = async () => {
            if (localStorage.getItem('type') === "ADMIN") {
                let plantilla = []
                paramsConfirmation.forEach((p) => {
                    if (p.TAG === 'pinEntity' || p.TAG === 'pinClient') {
                        plantilla.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION, REQUIRED: p.REQUIRED })
                    }
                    else {
                        if (localStorage.getItem('type') === 'CLIENT' && localStorage.getItem('number_id') && p.TAG === 'p_persona') {
                            plantilla.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION, REQUIRED: p.REQUIRED })
                        }
                        else {
                            plantilla.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                        }
                    }
                })
                setConfirmation(plantilla)
            }
        }
        confirmationTemplate()
    }, [params]);

    // Función mostrar modal lista de certificados
    const showModal = () => {
        setIsOpen(true);
    };

    // Función ocultar modal lista de certificados
    const hideModal = () => {
        setIsOpen(false);
    };

    const showModalCorreo = () => {
        setIsOpenCorreo(true);
    };

    // Función ocultar modal lista de certificados
    const hideModalCorreo = () => {
        setIsOpenCorreo(false);
    };

    const showModalConfirmacion = () => {
        setIsOpenConfirmacion(true);
    };

    // Función ocultar modal lista de certificados
    const hideModalConfirmacion = () => {
        setIsOpenConfirmacion(false);
    };


    // Función para generar reporte
    async function generateCertificate(mail = "", send = "NO") {
        const _cliente = localStorage.getItem('client')
        const _entity = localStorage.getItem('entity')
        const option = "1"

        let report = {
            CLIENT: _cliente,
            ENTITY: _entity,
            OPTION: option,
            SEND_MAIL: send,
            EMAIL: mail,
            REPORTS: []
        }

        let max = 0
        certificate.forEach(n => {
            let size = n.SHEET.length
            if (size > max) {
                max = size
            }
        })
        for (let i = 0; i < max; i++) {
            report.REPORTS.push({ PARAMETERS: [] })
        }

        certificate.forEach(n => {
            n.SHEET.forEach(e => {
                report.REPORTS[e].PARAMETERS.push({ LABEL: n.LABEL, VALUE: n.CODE })
            })
        })
        try {

            await apis.postPDF(report, headers).then(res => {
                let _contenido = res.data
                setContenido(_contenido);
                setLoading1(false)
                setLoading3(false)
                setLoading4(false)
                if (send === "NO") {
                    showModal()
                }
                else {
                    toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Correo enviado existosamente" })
                }
            })
        }
        catch (err) {
            setLoading1(false)
            setLoading3(false)
            setLoading4(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true })
        }
    }

    async function generateConfirmation() {
        const _cliente = localStorage.getItem('client')
        const _entity = localStorage.getItem('entity')
        const option = "1"

        let report = {
            CLIENT: _cliente,
            ENTITY: _entity,
            OPTION: option,
            REPORTS: []
        }

        let max = 0
        confirmation.forEach(n => {
            let size = n.SHEET.length
            if (size > max) {
                max = size
            }
        })
        for (let i = 0; i < max; i++) {
            report.REPORTS.push({ PARAMETERS: [] })
        }

        confirmation.forEach(n => {
            n.SHEET.forEach(e => {
                report.REPORTS[e].PARAMETERS.push({ LABEL: n.LABEL, VALUE: n.CODE })
            })
        })
        try {
            await apis.postConfirmation(report, headers).then(res => {
                let _contenido = res.data
                excelReport(_contenido, _contenido["SHEETS"][0].NAME)
                setLoading5(false)
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Archivo generado exitosamente" })
            })
        }
        catch (err) {
            setLoading5(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true })
        }
    }

    const sendMailCertificate = async () => {
        setLoading3(true)
        setLoading4(true)
        const mail = correo
        generateCertificate(mail, "SI")
    }

    // cuerpo de modal lista de certificados
    const itemTemplate = (data) => {
        let file = contenido.PDF[0].DATA
        return (
            <div className="product-item">
                {/* <img src="https://remunerwallet.s3.us-east-2.amazonaws.com/61/firma/unnamed.png" style={{ width: "50px" }} onError={(e) => e.target.src = 'https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png'} alt={data.name} /> */}
                <div className="product-detail">
                    <div className="product-name text-lg">{data.name}</div>
                    <div className="product-description">{data.description}</div>
                </div>
                <div className="product-action flex flex-row">
                    {contenido.PDF_OUTPUT === '1' ?
                        <Base64Downloader style={{ border: "0px", background: "transparent" }} base64={"data:application/pdf;base64," + file} downloadName="certificado" onDownloadSuccess={() => { setLoading2(false); hideModal() }}>
                            <Button icon="pi pi-arrow-down" loading={loading2} onClick={() => setLoading2(true)} />
                        </Base64Downloader>
                        :
                        <Button icon="pi pi-arrow-down" onClick={() => { window.open(file, "_blank"); hideModal() }} />
                    }
                </div>
            </div>
        );
    }

    // Configuración para parametros variables tipo select
    function handleChange(e, d, index) {
        setCertificate(n => {
            let newNomina = [...n]
            newNomina[index] = { ...e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newNomina
        })
    }

    // Configuración para parametros variables tipo calendar
    async function handleChangeDate(e, d, index) {
        let date = dateFormat(e.value)
        setCertificate(n => {
            let newNomina = [...n]
            newNomina[index] = { CODE: date, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newNomina
        })
    }

    // Configuración para parametros variables tipo Text
    async function handleChangeText(e, d, index) {
        setCertificate(n => {
            let newNomina = [...n]
            newNomina[index] = { CODE: e.target.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newNomina
        })
    }

    function handleChangeConfirmation(e, d, index) {
        setConfirmation(n => {
            let newNomina = [...n]
            newNomina[index] = { ...e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newNomina
        })
    }

    // Configuración para parametros variables tipo calendar
    async function handleChangeDateConfirmation(e, d, index) {
        let date = dateFormat(e.value)
        setConfirmation(n => {
            let newNomina = [...n]
            newNomina[index] = { CODE: date, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newNomina
        })
    }

    // Configuración para parametros variables tipo Text
    async function handleChangeTextConfirmation(e, d, index) {
        setConfirmation(n => {
            let newNomina = [...n]
            newNomina[index] = { CODE: e.target.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newNomina
        })
    }

    const mailFooter = (
        <Button label='Enviar' loading={loading3} onClick={() => sendMailCertificate()} />
    )

    const confirmationFooter = (
        <Button label='Generar' loading={loading5} onClick={() => generateConfirmation()} />
    )

    // Return que entrega la pantalla
    return (
        <div className='mt-6'>
            <Toast ref={toast} />

            <Dialog visible={isOpen}
                position="top" style={{ width: "36rem" }} draggable={false} resizable={false} modal onHide={hideModal}>
                <div className="datascroller-demo">
                    <div className="card">
                        <DataScroller value={listPdf} itemTemplate={itemTemplate} rows={5} inline scrollHeight="500px" header="Descarga el documento" />
                    </div>
                </div>
            </Dialog>
            <Dialog visible={isOpenCorreo} header="Enviar certificado por correo" footer={mailFooter}
                position="top" style={{ width: "36rem" }} draggable={false} resizable={false} modal onHide={hideModalCorreo}>
                <LabelField htmlFor="label">Correo*</LabelField>
                <InputText type='email' value={correo} onChange={(e) => setCorreo(e.target.value)} />
            </Dialog>
            {
                localStorage.getItem('type') === 'ADMIN' &&

                <Dialog visible={isOpenConfirmacion} header="Confirmación carta laboral" footer={confirmationFooter}
                    position="top" style={{ width: "36rem" }} draggable={false} resizable={false} modal onHide={hideModalConfirmacion}>
                    {paramsConfirmation.map((d, index) => {
                        if (d.TAG !== "pinClient" && d.TAG !== "pinEntity" && confirmation.length > 0 && typeof confirmation[index] !== "undefined") {
                            let label = d.LABEL
                            if (d.REQUIRED == "1") {
                                label = label + "*"
                            }
                            switch (d.TYPE) {
                                case "LIST":
                                    let options = []
                                    if (d.REQUIRED === "1") {
                                        options = [...d.OPTIONS]
                                    }
                                    else {
                                        options = [{ CODE: "NULL", NAME: "NO APLICA" }, ...d.OPTIONS]
                                    }
                                    return (<>
                                        <LabelField htmlFor="label">{label}</LabelField>
                                        <Dropdown
                                            key={index}
                                            style={elementWidth}
                                            value={confirmation[index]["NAME"]}
                                            options={options}
                                            disabled={localStorage.getItem("number_id") ? true : false}
                                            filter filterBy="NAME"
                                            optionLabel="NAME"
                                            placeholder={confirmation[index]["NAME"] ? confirmation[index]["NAME"] : "Seleccione"}
                                            onChange={(e) => handleChangeConfirmation(e, d, index)}
                                        />
                                    </>
                                    );
                                case "DATE":
                                    return (<>
                                        <LabelField htmlFor="label">{label}</LabelField>
                                        <Calendar key={d} style={elementWidth} id="navigators" value={confirmation[index]}
                                            onChange={(e) => handleChangeDateConfirmation(e, d, index)}
                                            locale="es" dateFormat="dd-mm-yy" showIcon placeholder="Seleccione"
                                            yearRange="2010:2030" /></>
                                    );
                                default:
                                    return (<>
                                        <LabelField htmlFor="label">{label}</LabelField>
                                        <InputText
                                            key={d}
                                            style={elementWidth}
                                            id="label2"
                                            type="text"
                                            value={confirmation[index].NAME}
                                            onChange={(e) => handleChangeTextConfirmation(e, d, index)}
                                        /></>
                                    )
                            }
                        }
                    })}
                </Dialog>
            }
            < div class="card w-8 m-auto  mt-6">
                <div class="grid">
                    <div class="col-12 ">
                        <div className="flex flex-row align-items-center justify-content-center font-bold text-4xl mt-4">
                            <span className="text-900">Certificados</span>
                            <Video header="Instructivo procesos usuarios y autogestión" url={localStorage.getItem('CERTIFICATE_VIDEO')} />
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="grid mt-3">
                            <div class="col-10 m-auto">
                                <div className="field">
                                    {localStorage.getItem('type') === 'ADMIN' && <Button className='mb-4' label="Confirmar carta laboral" onClick={() => { showModalConfirmacion() }} />}
                                    <div className='block'>
                                        <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
                                    </div>
                                    <div>
                                        {params.map((d, index) => {
                                            if (d.TAG !== "pinClient" && d.TAG !== "pinEntity" && certificate.length > 0 && typeof certificate[index] !== "undefined") {
                                                let label = d.LABEL

                                                if (d.REQUIRED == "1") {
                                                    label = label + "*"
                                                }
                                                switch (d.TYPE) {
                                                    case "LIST":
                                                        let options = []
                                                        if (d.REQUIRED === "1") {
                                                            options = [...d.OPTIONS]
                                                        }
                                                        else {
                                                            options = [{ CODE: "NULL", NAME: "NO APLICA" }, ...d.OPTIONS]
                                                        }
                                                        return (<>
                                                            <LabelField htmlFor="label">{label}</LabelField>
                                                            <Dropdown
                                                                key={index}
                                                                style={elementWidth}
                                                                value={certificate[index]["NAME"]}
                                                                options={options}
                                                                disabled={localStorage.getItem("number_id") ? true : false}
                                                                filter filterBy="NAME"
                                                                optionLabel="NAME"
                                                                placeholder={certificate[index]["NAME"] ? certificate[index]["NAME"] : "Seleccione"}
                                                                onChange={(e) => handleChange(e, d, index)}
                                                            />
                                                        </>
                                                        );
                                                    case "DATE":
                                                        return (<>
                                                            <LabelField htmlFor="label">{label}</LabelField>
                                                            <Calendar key={d} style={elementWidth} id="navigators" value={certificate[index]}
                                                                onChange={(e) => handleChangeDate(e, d, index)}
                                                                locale="es" dateFormat="dd-mm-yy" showIcon placeholder="Seleccione"
                                                                yearRange="2010:2030" /></>
                                                        );
                                                    default:
                                                        return (<>
                                                            <LabelField htmlFor="label">{label}</LabelField>
                                                            <InputText
                                                                key={d}
                                                                style={elementWidth}
                                                                id="label2"
                                                                type="text"
                                                                value={certificate[index].NAME}
                                                                onChange={(e) => handleChangeText(e, d, index)}
                                                            /></>
                                                        )
                                                }
                                            }
                                        })} </div>
                                </div>
                            </div>

                            <div class="col-10 m-auto">
                                <hr class="my-3 mx-0 border-top-1 " />
                                <Button label="Generar Documento" loading={loading1} onClick={() => { setLoading1(true); generateCertificate() }} />
                                &nbsp;
                                <Button label='Enviar por correo' loading={loading4}
                                    onClick={() => {
                                        if (localStorage.getItem('type') === "ADMIN") {
                                            showModalCorreo()
                                        }
                                        else {
                                            sendMailCertificate()
                                        }
                                    }
                                    } />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
}